import { createGlobalStyle } from 'styled-components';

import MQ from './attrs/mq';

const AntGlobalStyle = createGlobalStyle`
  // Antd: Alert
  .ant-alert {
    margin-bottom: 1rem;
  }

  // Antd: Card
  .ant-card-head {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .ant-card-body {
    padding: 1rem;

    :empty {
      display: none;
    }
  }

  .ant-card-head-title {
    ${MQ.md`
      font-size: 1.1rem;
      font-weight: bold;
    `}
  }

  .ant-card-extra {
    :empty {
      display: none;
    }
  }

  .ant-card-small {
    .ant-card-head,
    .ant-card-head-title {
      font-size: 1rem;
    }

    .ant-card-head {
      min-height: 40px;
    }
  }

  // Antd: Button & RadioButton
  .ant-btn,
  .ant-radio-button-wrapper {
    font-size: 0.9rem;
    padding-left: 12px;
    padding-right: 12px;
  }

  // Antd: Dropdown
  .ant-dropdown-trigger {
    padding-left: 12px;
    padding-right: 12px;
  }

  // Antd: Radio.Group as flex
  .ant-radio-group-flex {
    display: flex;

    .ant-radio-button-wrapper {
      flex: 1;
      text-align: center;
    }
  }

  // Antd: Form
  .ant-form-item {
    margin-bottom: 0.5rem;

    ${MQ.md`
      margin-bottom: 1.5rem;
      margin-bottom: 1.5rem;
    `}
  }

  .ant-form-item:last-of-type {
    margin-bottom: 0;
  }

  .ant-form-item-label {
    padding: 0 !important;
  }

  // Antd: Modal
  .ant-modal {
    transform: unset !important;
    transform-origin: unset !important;
  }

  .ant-modal-footer {
    padding: 10px 24px;
  }

  // Antd: Select & Dropdown
  .ant-select,
  .ant-select-dropdown,
  .ant-dropdown-menu-item {
    font-size: 0.9rem;
  }

  // Antd: Radio
  .ant-checkbox-wrapper {
    display: flex;
    align-items: flex-start;

    .ant-checkbox {
      margin-top: 4px;
    }

    .ant-checkbox + span {
      line-height: 1.5;
      display: block;
    }
  }

  // Antd: tabs
  .ant-tabs-nav .ant-tabs-tab,
  .ant-tabs-nav .ant-tabs-tab-active {
    font-weight: bold;
  }

  // Antd: datepicker
  .ant-picker-panels {
    flex-direction: column;

    ${MQ.sm`
      flex-direction: row;
    `}
  }
`;

export default AntGlobalStyle;
